import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
export function OpeningHookSection() {
  return <section className="w-full bg-cream py-20 px-4" data-id="element-166">
      <motion.div className="max-w-3xl mx-auto" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} data-id="element-167">
        <div className="bg-warmWhite rounded-3xl p-8 sm:p-12 shadow-warm border border-terracotta-100" data-id="element-168">
          <div className="flex justify-center mb-8" data-id="element-169">
            <div className="w-12 h-12 bg-terracotta-100 rounded-full flex items-center justify-center" data-id="element-170">
              <HeartIcon className="w-6 h-6 text-terracotta" data-id="element-171" />
            </div>
          </div>

          <p className="font-heading text-xl sm:text-2xl text-charcoal leading-relaxed italic text-center mb-8" data-id="element-172">
            Son las 3 de la mañana. Estás sentada en la oscuridad, con la
            espalda adolorida y el corazón acelerado, rogando en silencio que tu
            bebé no abra los ojos en cuanto lo dejes en la cuna. Sientes que la
            falta de sueño está nublando tu juicio y que ya no tienes fuerzas
            para una noche más.
          </p>

          <div className="w-16 h-0.5 bg-terracotta-200 mx-auto mb-8" data-id="element-173" />

          <p className="font-body text-lg text-warmGray text-center leading-relaxed" data-id="element-174">
            <span className="font-semibold text-charcoal" data-id="element-175">No estás sola.</span>{' '}
            El agotamiento extremo no es una "etapa normal" que debes aguantar
            en silencio; es una emergencia de salud mental y física que{' '}
            <span className="text-terracotta font-semibold" data-id="element-176">
              tiene solución
            </span>
            .
          </p>
        </div>
      </motion.div>
    </section>;
}